import { IElement, OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type QuantityAutoChange =
  ProjectChangeMap[ProjectChangeType.ElementQuantityAutoUpdate];

/**
 * Build a partial element change for ElementQuantityAutoUpdate.
 * Replaces the element's full quantity record (from structural enrichment).
 *
 * @param element - Current element state
 * @param change - Quantity auto-update payload
 * @returns Partial with quantity, or undefined if not an element. No-op filtering: `projectChangeToElementPartial`.
 */
export const elementQuantityAutoUpdateToChange = (
  element: OneOfElements,
  change: QuantityAutoChange,
): Partial<IElement> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;

  return { quantity: change.quantity };
};
